import type { RequiredDocumentCode } from '@/config/requiredDocumentsCodes.ts'

export class DocumentToAcceptError extends Error {
    documentToAccept: RequiredDocumentCode
    subAccountId: string | null

    constructor(
        documentToAccept: RequiredDocumentCode,
        message: string,
        { subAccountId = null }: { subAccountId?: string | null } = {},
    ) {
        super(message)

        this.name = 'DocumentToAcceptError'
        Object.setPrototypeOf(this, DocumentToAcceptError.prototype)
        this.documentToAccept = documentToAccept
        this.subAccountId = subAccountId
    }
}
